import React from "react";
import { connect } from "react-redux";
import { FiCornerUpLeft, FiRotateCcw, FiEdit2, FiTrash2 } from "react-icons/fi";

function Table({ columns = [], list = [], onEdit, onView, onStatus, onDelete }) {

  const formatValue = (item, col, index) => {
    return item[col.key] || "-";
  };

  const actionButtons = [
    {
      icon: <FiCornerUpLeft size={18} />,
      label: "Responses",
      onClick: onView,
    },
    {
      icon: <FiRotateCcw size={18} />,
      label: "Status Logs",
      onClick: onStatus,
    },
    {
      icon: <FiEdit2 size={18} />,
      label: "Edit",
      onClick: onEdit,
    },
    // {
    //   icon: <FiTrash2 size={18} />,
    //   label: "Delete",
    //   onClick: onDelete,
    // },
  ];

  return (
    <div className="overflow-x-auto overflow-y-auto">
      <table className="w-full text-left border-collapse">

        {/* HEADER */}
        <thead className="bg-indigo-100 text-base border-b border-gray-300">
          <tr>
            {columns.map((col, i) => (
              <th key={i} className="md:px-6 px-3 py-4 whitespace-nowrap">
                {col.label}
              </th>
            ))}
            <th className="md:px-6 px-3 py-4 text-center whitespace-nowrap">Action</th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody className="divide-y divide-gray-300">
          {list.length > 0 ? (
            list.map((item, index) => (
              <tr
                key={item._id || index}
                className="transition-colors text-sm"
              >
                {columns.map((col, i) => (
                  <td key={i} className="md:px-6 px-3 py-3 whitespace-nowrap">
                    {formatValue(item, col, index)}
                  </td>
                ))}

                {/* ACTION */}
                <td className="md:px-6 px-3 py-3">
                  <div className="flex justify-center gap-3 whitespace-nowrap">
                    {actionButtons.map((btn, index) => (
                      <button
                        key={index}
                        onClick={() => btn.onClick && btn.onClick(item)}
                        className="relative group p-2 rounded-md cursor-pointer bg-indigo-100 hover:bg-indigo-200 transition-all duration-100"
                      >
                        {btn.icon}

                        <span className="absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 transition">
                          {btn.label}
                        </span>
                      </button>
                    ))}
                  </div>
                </td>



                {false && <button

                  className="relative group border text-[#3D405B]/70 hover:text-[#4CAF50]
                                                  p-2 rounded cursor-pointer hover:bg-[#4CAF50]/10
                                                  transition-all duration-100"
                >
                  {/* Icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-device-floppy " width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><rect x="9" y="3" width="6" height="4" rx="2" /><line x1="9" y1="12" x2="9.01" y2="12" /><line x1="13" y1="12" x2="15" y2="12" /><line x1="9" y1="16" x2="9.01" y2="16" /><line x1="13" y1="16" x2="15" y2="16" /></svg>

                  {/* Tooltip */}
                  <span
                    className="absolute -top-9 left-1/2 -translate-x-1/2
                                                  whitespace-nowrap rounded bg-gray-900 px-2 py-1
                                                  text-xs text-white opacity-0
                                                  group-hover:opacity-100 transition"
                  >
                    Talent Report
                  </span>
                </button>
                }


              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length + 1}
                className="text-center py-6 text-gray-500"
              >
                No Data Found
              </td>
            </tr>
          )}
        </tbody>

      </table>
    </div >
  );
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(Table);